export const initialState = {
	selectedItem: undefined,
	selectedItemChangesClone: undefined,
	isSavingItem: false,
	newItem: undefined,
	isSavingNewItem: undefined,
	errorMessageSaveNewItem: undefined,
	isSavingEditedItem: undefined,
	errorMessageSaveEditedItem: undefined,
	isDeletingItem: undefined,
	errorMessageDeleteItem: undefined,
	showConfirmation: false,
  confirmationMessageKey: undefined,
  showValidation: false,
};

export default initialState;
